module.exports = __webpack_public_path__ + "img/avatar1.aac14ce4.jpg";